import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class ContactPersonListDivs extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        const {
            contactPersons,
            onClone,
            onDelete,
            intl
        } = this.props;

        return (
            <div>
            {
                contactPersons.map(person => {
                    return (
                        <div key={person.id}>
                            <div className="row">
                                <div className="col-12">#{person.id}</div>
                                <div className="col-12"><strong>{intl.formatMessage(messages.listDivTitleHeading)}</strong></div>
                                <div className="col-12">{person.workingTitle}</div>
                                <div className="col-12"><strong>{intl.formatMessage(messages.contactPersonListDivTitleName)}</strong></div>
                                <div className="col-12">{person.name}</div>
                                <div className="col-12"><strong>{intl.formatMessage(messages.listDivTitleEmail)}</strong></div>
                                <div className="col-12">{person.email}</div>
                                <div className="col-12"><strong>{intl.formatMessage(messages.listDivTitlePhone)}</strong></div>
                                <div className="col-12">{person.phone}</div>
                                <div className="col-12 text-right mt-3">

                                    <div className="btn-group text-right mt-1">
                                        <Link
                                            to={`/kontaktperson/redigere/${person.id}`}
                                            title={intl.formatMessage(messages.listDropDownButtonEdit)}
                                            className="btn btn-secondary waves-effect list-action mt-2"
                                        >
                                            <i className="fa fa-pencil"/> {intl.formatMessage(messages.listDropDownButtonEdit)}
                                        </Link>
                                        <button
                                            type="button"
                                            className="btn clickable btn-secondary dropdown-toggle mt-2"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            <span className="sr-only">{intl.formatMessage(messages.listDropDownButtonOptions)}</span>
                                        </button>
                                        <div className="dropdown-menu">
                                            <button
                                                title={intl.formatMessage(messages.listDropDownButtonClone)}
                                                type="button"
                                                className="dropdown-item clickable"
                                                onClick={() => onClone(person.id)}
                                            >
                                                <i className="fa fa-clone"/> {intl.formatMessage(messages.listDropDownButtonClone)}
                                            </button>
                                            <div className="dropdown-divider"/>
                                            <button type="button"
                                                    className="dropdown-item clickable"
                                                    onClick={() => onDelete(person.id)}
                                            >
                                                <i className="fa fa-trash-o"/> {intl.formatMessage(messages.listDropDownButtonDelete)}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>
                        )
                })
            }
            </div>
        )
    }
}

export default injectIntl(ContactPersonListDivs);




// WEBPACK FOOTER //
// ./web/src/components/contact-person/ContactPersonListDivs.jsx